import type { FaireProductEntity } from "../../entity_types/product";

export const p_6n6bm2fsu8: FaireProductEntity = {
  token: "p_6n6bm2fsu8",
  type: "product",
  name: "Mahjong Tile Themed Transfer Paper Designed Polymer Clay Charms",
  brandToken: "b_wjpfk5j84w",
  brandName: "Morning Dew Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/530adac27c7a62ee7c08c440390b8cd20bbb08bc2326b36d2badb31128748803.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f35495da144ff490e9069c86b6199ad5e8a6b04f5fbf4500bdcbb5e695254bcc.jpeg",
    "https://cdn.faire.com/fastly/ad5ec2a602f1aa73c4dd813beb3aaae1f7b9d84f4add549f2895e5beb1b92f13.jpeg",
  ],
  priceDollars: 6,
  description:
    'Bring a little luck and charm to your next creation with these adorable miniature polymer clay Mahjong tile charms! Each charm is handcrafted from lightweight polymer clay and features delicate Mahjong-inspired artwork, including classic bam, dot, crak, flowers, winds, and whimsical joker and dragon designs.\n\nCharms sold individually and range in size from .4 to .75 inches. You may also select "Entire Collection" and you will receive one of each charm from this entire collection. You will have to choose the collection by finish.\n\nPaperclip Chain Necklaces are 16" + a 2" extender with a lobster claw clasp. Paperclip Chain Bracelets are 7". Available in 18K Gold PVD Stainless Steel and Silver Stainless Steel. The 18K Gold jewelry is PVD coated over 316L surgical grade stainless steel for a non-tarnish, hypoallergenic, polished finish.\n',
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:50.395Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
